import Icon, { IconProps } from './Icon';

import LayoutLeftIcon from '../../../assets/icons/layout-left.svg?react';

const LayoutLeft: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <LayoutLeftIcon />
    </Icon>
  );
};

export default LayoutLeft;
